module.exports = __webpack_public_path__ + "static/texas-health-1-51a42ba6d1e0e8fb4f674f2686aa1e58.png";